module.exports = __webpack_public_path__ + "static/media/header-bg.9f488114.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/redesign/header-bg.jpg
// module id = 1737
// module chunks = 0